import { useEffect, useState } from "react";
import debounce from "lodash.debounce";

interface Output {
  deviceVh: number;
}

/**
 * Get device real viewport height value (1vh) as px
 *
 * Fix for mobile devices and miscalculation of css vh
 * due to URL bar, bottom bar, etc (especially on iOS devices)
 */
const useDeviceVh = (): Output => {
  const [deviceVh, setDeviceVh] = useState(0);

  const measureVh = (): void => {
    const realVh = window.innerHeight / 100;

    setDeviceVh(realVh);
  };

  useEffect(() => {
    const resizeListener = debounce(() => measureVh(), 300);

    window.addEventListener("resize", resizeListener);

    measureVh();

    return () => {
      window.removeEventListener("resize", resizeListener);
    };
  }, []);

  return {
    deviceVh,
  };
};

export default useDeviceVh;
